/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgIfc = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="m12.14 4.151 1.743-1.633a1.977 1.977 0 0 1 2.763.093l4.73 5.03a1.957 1.957 0 0 1-.093 2.746l-4.21 3.971a1.954 1.954 0 0 1-2.745-.093l-.316-.334 5.305-4.992-4.118-4.38-1.428 1.337zm-7.976 7.702-1.632-1.745a1.946 1.946 0 0 1 .093-2.765L7.65 2.611a1.954 1.954 0 0 1 2.745.093l3.95 4.212a1.94 1.94 0 0 1-.074 2.747l-.334.316L8.95 4.67 4.573 8.79l1.335 1.429zm5.082 2.542a1.937 1.937 0 0 1-2.745-.074l-.297-.315 3.97-3.768 1.631 1.745zm5.082 3.1a1.94 1.94 0 0 0 .074-2.747l-2.411-2.561-1.744 1.633 3.747 3.99zm-2.467 2.338-1.744 1.633a1.936 1.936 0 0 1-2.744-.074l-4.73-5.03a1.94 1.94 0 0 1 .074-2.746l4.21-3.971a1.937 1.937 0 0 1 2.745.074l.316.334-5.305 4.992 4.118 4.38 1.428-1.337zm5.638-10.17a1.954 1.954 0 0 0-2.745-.093l-2.56 2.413 1.633 1.744 3.988-3.749zm2.337 2.468 1.632 1.745a1.945 1.945 0 0 1-.093 2.765l-5.026 4.732a1.954 1.954 0 0 1-2.745-.093l-3.969-4.213a1.94 1.94 0 0 1 .074-2.746l.334-.316 5.008 5.308 4.377-4.12-1.335-1.429zM9.672 6.49a1.94 1.94 0 0 0-.074 2.746l2.411 2.561 1.744-1.633-3.747-3.99z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgIfc as Ifc };
